/* eslint-disable no-template-curly-in-string */
/* eslint-disable prettier/prettier */
/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
// import { GoogleMap, Marker } from "react-google-maps";
import React from 'react';
import { observer } from 'mobx-react';
import { Modal, ModalBody, ModalFooter, ModalHeader } from '@msdyn365-commerce-modules/utilities';
import { ICartState } from '@msdyn365-commerce/global-state';

export interface IAddressListModalProps {
    isOpen: any;
    onRequestClose: () => void;
    addressData: any;
    activeModalContent: string;
    setActiveModalContent: (data: string) => void;
    addressPurposes: any;
    selectedAddress: any;
    setSelectedAddress: (data: any) => void;
    setAddressBarDetails: (data: string) => void;
    isEligibleForQuickDelivery: (lat: number, lng: number) => any;
    setAddressLatLng: (data: any) => void;
    cart?: ICartState | undefined;
    userToken?: string;
    isEligibleForQD?: boolean;
}

/**
 *
 * AddressListModal component.
 * @extends {React.PureComponent<IAddressListModalProps>}
 */

@observer
export class AddressListModal extends React.PureComponent<IAddressListModalProps> {
    constructor(props: IAddressListModalProps) {
        super(props);
    }

    public componentDidMount() {

    }
    public componentDidUpdate(): void {

    }

    public async confirmSelectAddress() {
        this.props.onRequestClose();
        const element = document.querySelector(`input[type='radio'][name=selected-address]:checked`) as HTMLInputElement;
        if(element){
            const id = element.dataset?.id;
            const addressObj = this.props.addressData.filter((item: any) => {
                return Number(item.RecordId) === Number(id);
            });
            console.log('this all address details : ', id, this.props.addressData, addressObj);
            this.props.setAddressBarDetails(element.dataset?.street ? element.dataset?.street : 'Select location');
            const latLngtObject = element.dataset?.latlng && element.dataset?.latlng.split(',');
            const latitude = latLngtObject && latLngtObject.length > 0 ? Number(latLngtObject[0]) : 0;
            const longitutude = latLngtObject && latLngtObject.length > 0 ? Number(latLngtObject[1]) : 0;
            const QDEligibility = await this.props.isEligibleForQuickDelivery(latitude, longitutude);
            this.props.setAddressLatLng(JSON.stringify({ lat: latitude, lng: longitutude }));
            // Patch this selected address to cart
            addressObj && addressObj?.length > 0 && this.patchAddressToCart(addressObj[0], QDEligibility);
        }
    }

    public async patchAddressToCart(addressObj: any, QDEligibility: boolean): Promise<void> {
        if(this.props.cart?.cart?.CartLines && this.props.cart?.cart?.CartLines?.length > 0 && this.props.cart?.cart?.Id && this.props.cart?.cart?.Id !== ''){
            const deliveryType = QDEligibility ? 'QD_CC' : 'FREE';
            const cartItems = this.props.cart?.cart?.CartLines.map((val: any) => {
                return {
                  LineId: val.LineId,
                  DeliverySpecification: {
                    DeliveryModeId: deliveryType,
                    DeliveryPreferenceTypeValue: 1,
                    DeliveryAddress: addressObj,
                  },
                };
            });
            console.log('this.props.isEligibleForQD : ', this.props.isEligibleForQD, deliveryType, QDEligibility);

            try {
                const payload = { lineDeliverySpecifications: cartItems };
                // eslint-disable-next-line @typescript-eslint/no-require-imports
                const axios = require('axios');
                let config = {
                    method: 'post',
                    maxBodyLength: Infinity,
                    url: `https://api.localy.ae/cart/${this.props.cart?.cart?.Id}/UpdateLineDeliverySpecifications?api-version=7.3`,
                    // url: `https://apidev.localy.ae/cart/${this.props.cart?.cart?.Id}/UpdateLineDeliverySpecifications?api-version=7.3`,
                    headers: {
                    'Accept': 'application/json',
                    'Authorization': `id_token ${this.props.userToken}`,
                    'Cache-Control': 'no-cache',
                    'oun': '00000001',
                    'Content-Type': 'application/json'
                    },
                    data : payload
                };
                await axios.request(config)
                .then(async (response: any) => {
                    await this.patchCartAttributes();
                })
                .catch((error: any) => {
                });
            } catch (error) {
              // Handle error
            }
        }
    }

    public async patchCartAttributes() {
        // eslint-disable-next-line @typescript-eslint/no-require-imports
        const axios = require('axios');
        const data = JSON.stringify({
            "AttributeValues": [
                {
                    "@odata.type": "#Microsoft.Dynamics.Commerce.Runtime.DataModel.AttributeTextValue",
                    "Name": "Order Channel Type",
                    "TextValue": "Web",
                    "ExtensionProperties": [],
                    "TextValueTranslations": []
                }
            ]
        });

        const config = {
            method: 'patch',
            maxBodyLength: Infinity,
            // url: `https://apidev.localy.ae/cart/${this.props.cart?.cart?.Id}?api-version=7.3`,
            url: `https://api.localy.ae/cart/${this.props.cart?.cart?.Id}?api-version=7.3`,
            headers: {
                'Accept': 'application/json',
                'Authorization': `id_token ${this.props.userToken}`,
                'Content-Type': 'application/json',
                'accept-language': 'en-US',
                'oun': '00000001',
                'prefer': 'return=representation'
            },
            data : data
        };

        axios.request(config)
          .then((response:any) => {
              console.log('address repatch cart attr response',JSON.stringify(response.data));
          })
          .catch((error:any) => {
              console.log(error);
          });

    }
    public render(): JSX.Element {
        return (
            <Modal isOpen={this.props.isOpen} toggle={this.props.onRequestClose} modalClassName='address-lsit-modal'>
                <div className='row localy-address'>
                <ModalHeader>
                    <div className='row saved-address-top'>
                        <div className='saved-address'>
                            Saved Address
                        </div>
                        <div className='add-new-address'>
                            <button onClick={() => {this.props.setActiveModalContent('location');}} className='add-new-address-global'>
                                <span>Add New Address</span>
                            </button>
                        </div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    {this.props.addressData.map((item: any) => {
                        const addressType = this.props.addressPurposes.filter(
                            (addressTypeValue: { AddressType: any }) => addressTypeValue.AddressType === item.AddressTypeValue
                        );
                        const addressTypeValue = addressType.length > 0 ? addressType[0].Description : '';
                            return (
                                <>
                                    <div className="global-address">
                                        <input type='radio' value={item?.RecordId} name='selected-address'
                                        checked={this.props.selectedAddress === item.RecordId} onClick={() => {
                                            this.props.setSelectedAddress(item.RecordId);
                                            this.props.setAddressBarDetails(`${addressTypeValue} - ${item.Street}`);
                                        }}
                                         data-street={`${addressTypeValue} - ${item.Street}`}
                                         data-latLng={`${item.DistrictName}`}
                                         data-id={`${item.RecordId}`}
                                         className="msc-address-select__input"></input>

                                        <div className='address-detail'>
                                            <p className='ms-address-type'>
                                                <span className='ms-address-type-value'>{addressTypeValue}</span>
                                            </p>
                                            <p className='ms-address-details'>
                                                {`${item.Street}`}
                                                {item?.StreetNumber && item?.StreetNumber !== '' && ` , ${item.StreetNumber}`}
                                                {item?.BuildingCompliment && item?.BuildingCompliment !== '' && ` , ${item.BuildingCompliment}`}
                                                {item?.City && item?.City !== '' && ` , ${item.City}`}
                                            </p>
                                            <p className='ms-address-name'>{`${item.Name}, ${item.Phone}`}</p>
                                        </div>
                                    </div>
                                </>
                            );
                        })}
                </ModalBody>
                <ModalFooter>
                    <button onClick={() => {this.confirmSelectAddress();}} className='confirm-address-button deliver-here-button'>
                        <span>Delivery Here</span>
                    </button>

                </ModalFooter>
                </div>
            </Modal>
        );
    }
}
